import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Returns the URL to which a fan should be redirected after a successful login.
 *
 * If the URL is not specified in the query string, the default is `/games`.
 */
export function useAfterLoginRedirectUrl() {
  const [searchParams] = useSearchParams();
  const redirectToParam = searchParams.get("redirectTo");

  return useMemo(() => {
    return redirectToParam ?? "/games";
  }, [redirectToParam]);
}
